import { useServicesContext } from "@modules/core/services/services.context"
import { PayoutDetailsEntity, PayoutItemEntity } from "@modules/financesPayout/entities/payoutEntity"
import { PayoutEnumApi } from "@modules/financesPayout/gateway/payoutApi"
import { useQuery } from "@tanstack/react-query"

export const usePayouts = (payoutEnumApi: PayoutEnumApi) => {
  const { payoutApi } = useServicesContext()

  const key = payoutEnumApi === PayoutEnumApi.OWNER ? "boxPayouts" : "userPayouts"
  const { data, isLoading } = useQuery({
    queryKey: [key, payoutEnumApi],

    queryFn: async () => {
      return await payoutApi.getPayouts(payoutEnumApi)
    },
  })

  return {
    data: data?.map((payout) => PayoutItemEntity.fromItemDto(payout)) || [],
    isLoading,
  }
}

export const usePayout = (payoutEnumApi: PayoutEnumApi, payoutId: string | null) => {
  const { payoutApi } = useServicesContext()

  const key = payoutEnumApi === PayoutEnumApi.OWNER ? "boxPayout" : "userPayout"
  const { data, isLoading } = useQuery({
    queryKey: [key, payoutId, payoutEnumApi],

    queryFn: async () => {
      if (!payoutId) return null
      return await payoutApi.getPayout(payoutEnumApi, payoutId)
    },
  })

  return {
    data: data ? PayoutDetailsEntity.fromDto(data) : null,
    isLoading,
  }
}
